import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";

export const rockClimbingDetectExample: TemplateDefinition = {
  mode: "detect",
  slug: "rock-climbing-detect-example",
  version: 1,
  title: "Climbing",
  description: "Trace routes by color",
  subdescription: "Separate climbing holds by their route color on the wall.",
  thumbnailUuid: BASE_ASSETS.climbExample.uuid,
  assets: [BASE_ASSETS.climbExample],
  detect: {
    mediaUuid: BASE_ASSETS.climbExample.uuid,
    categories: ["pink holds", "blue holds", "black holds", "white holds", "green holds"],
    config: {
      output: "box",
      enableThinking: true,
    },
  },
};
